import { render } from "./IconEarnPoint.vue?vue&type=template&id=66971756"
import script from "./IconEarnPoint.vue?vue&type=script&lang=js"
export * from "./IconEarnPoint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__